export default __webpack_public_path__ + "static/media/hand_meet.df25e14a.svg";